import axios from 'axios';

export const COMMON_API_URL = `${process.env.VUE_APP_COMMON_API_URL}`;

export function fetchTasks({ userId, token, instance }) {
  return axios({
    url: `${COMMON_API_URL}/tasks/`,
    method: 'GET',
    params: {
      user_id: userId,
      token,
      instance,
    },
  }).then(response => response.data);
}

